import { GetInviteFriendResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getInviteFriend } from '../../services'
import { InviteFriendQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetInviteFriend(
	props?: UseBaseQueryOptions<GetInviteFriendResponse>,
) {
	return useQuery({
		queryKey: [InviteFriendQueryKeys.GetInviteFriend],
		queryFn: () => getInviteFriend(),
		...props,
	})
}
